/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import "jspdf-autotable";
import ajaxBank from "../../util/remote/ajaxBank";
import MMChargesSearchForm from "../Common/Transactions/MMChargesSearchForm";
import TableHeader from "../Common/TableHeader";
import Pagination from "../Common/Pagination";
import Loader from "../Common/Loader";

function MMChargesList() {
  const [startDate, setStartDate] = useState("");

  const [endDate, setEndDate] = useState("");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const [meta, setMeta] = useState([]);
  const [mmCharges, setMMCharges] = useState([]);

  useEffect(() => {
      if (startDate || endDate) {
          searchMMCharges();
      } else {
          getMMCharges(page);
      }
  }, [page]);
  
  const getMMCharges = async (currentPage) => {
      setLoading(true);
      const server_response = await ajaxBank.fetchMMChargesList(currentPage);
      setLoading(false);
      if (server_response.status === "OK") {
        setMeta(server_response.details.meta.totalPages);
        setMMCharges(server_response.details.data || []);
      } else {
        setMMCharges([]);
      }
  };

  const searchMMCharges = async (e) => {
      if (e) {
        e.preventDefault();
      }
      setLoading2(true);
      const server_response = await ajaxBank.searchMMChargesList(page,startDate,endDate);
      setLoading2(false);
      if (server_response.status === "OK") {
        setMeta(server_response.details.meta.totalPages);
        setMMCharges(server_response.details.data || []);
      } else {
        setMMCharges([]);
      } 
  };

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  const setCharges = (e) => {
    e.preventDefault();
    setStartDate("");
    setEndDate("");
    setPage(1);
    getMMCharges(1);
    
  };


  return (
    <div className="col-lg-12 col-md-12 mt-3">
              <div className="card height-auto">
                <div className="card-body">
                <div class="heading-layout1 mg-b-5">
        <TableHeader
          title = "MM Charges List"
          subtitle="List of all the mobile money charges sorted by the most recent"    
        />
        <div class="dropdown">
          <Link class="dropdown-toggle" role="button" data-toggle="dropdown" aria-expanded="false">...</Link>
          <div class="dropdown-menu dropdown-menu-right">
            <Link class="dropdown-item" onClick={setCharges}> <i class="fas fa-redo-alt text-orange-peel"></i>Refresh</Link>
          </div>
        </div>
      </div>

      <MMChargesSearchForm startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} searchCharges={searchMMCharges}
      resetSearch={setCharges}/>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
      {loading || loading2 ? (
        <Loader />
                      ) : (
        <table className="table display data-table text-nowrap">
            <thead>
                <tr>
                <th scope="col">Transaction Date</th>
                <th scope="col">Phone Number</th>
                <th scope="col"> Charge Amount</th>
                <th scope="col"> Charge Type</th>

                </tr>
            </thead>
            <tbody>
                {mmCharges.length > 0 ? (
                    mmCharges.map((item, index) => (
                    <tr key={index}>
                        

                        <td>
                        {item.created_at?.short_date}
                        <br />
                      <small>
                      {item.created_at?.time}
                      </small>
                        </td>
                        
                        <td>{item.phone_number}</td>
                        <td>{item.amount}</td>
                        <td>{item.type ==="Deposit"? <span class="badge badge-success">{item.account}</span>:<span class="badge badge-danger">{item.account}</span>}</td>
                    </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="4" style={{ textAlign: "center" }}>
                            No mm charges yet.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
      )}
        
      </div>
      <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
                </div>
              </div>
          </div>
  );
}

export default MMChargesList;
